/**
 * Unified address formatting utility.
 *
 * Replaces ~5 inline address concatenation patterns across the codebase.
 * Handles missing fields gracefully by filtering falsy parts.
 */

interface AddressFields {
  propertyAddress?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

/**
 * "123 Vine St, Napa, CA, 94558"
 * Full address — street, city, state, zip. Skips missing parts.
 */
export function formatAddress(fields: AddressFields): string {
  return [fields.propertyAddress, fields.city, fields.state, fields.zipCode]
    .filter(Boolean)
    .join(', ');
}

/**
 * "123 Vine St, Napa, CA"
 * Street + city + state (no zip). For display contexts where zip is noise.
 */
export function formatAddressShort(fields: AddressFields): string {
  return [fields.propertyAddress, fields.city, fields.state]
    .filter(Boolean)
    .join(', ');
}
